import { SearchEditionPagination } from './search-edition-results';

export type SectionKey = 'all' | 'body' | 'listApp' | 'notes' | 'biblio' | 'trans_en' | 'trans_la';

export interface Section {
    key: SectionKey;
    label: string;
}

export interface PatternDistance {
    key: number;
    label: string;
}

export interface ListAppField {
    key: number;
    label: string;
}

export interface ListAppWitness {
    key: string;
    label: string;
}

export interface ListAppWitnessHand {
    key: string;
    label: string;
}

export interface ListAppCause {
    key: string;
    label: string;
}

export type ListAppCauses = Array<ListAppCause>;

export const PATTERN_DISTANCES: Array<PatternDistance> = [
    {key: 1, label: '1'},
    {key: 5, label: '5'},
    {key: 10, label: '10'},
    {key: 20, label: '20'}
];

export const EDITION_SECTIONS: Array<Section> = [
    {key: 'all', label: 'All'},
    {key: 'body', label: 'Arabic text'},
    {key: 'listApp', label: 'Critical apparatus'},
    {key: 'notes', label: 'Notes'},
    /* {key: 'biblio', label: 'Bibliography'}, */
    {key: 'trans_en', label: 'English translation'},
    {key: 'trans_la', label: 'Latin translation'}
];

export const LISTAPP_FIELDS: Array<ListAppField> = [
    {key: 1, label: 'Lemmas and readings'},
    {key: 2, label: 'Readings'},
    {key: 3, label: 'Notes'}
];

export const RESULTS_SECTION_LABELS: Array<Section> = [
    {key: 'body', label: 'paragraphs'},
    {key: 'listApp', label: 'elements'},
    {key: 'notes', label: 'exegetical notes'},
    /* {key: 'biblio', label: 'bibliography'}, */
    {key: 'trans_en', label: 'paragraphs'},
    {key: 'trans_la', label: 'paragraphs'}
];

export const RESULTS_LIMIT = 20;

export class ListAppSearchParams {
    private _fields: number;
    private _witnesses: Array<string>;
    private _hands: Array<string>;
    private _causes: Array<string>;

    constructor() {
        this.init();
    }

    init(): void {
        this._fields = LISTAPP_FIELDS[0].key;
        this._witnesses = [];
        this._hands = [];
        this._causes = [];
    }

    /* Main fields of the critical apparatus involved  */
    get fields(): number {
        return this._fields;
    }

    set fields(value: number) {
        if (value) {
            this._fields = value;
        } else {
            this._fields = LISTAPP_FIELDS[0].key;
        }
    }

    /* Witnesses involved  */
    get witnesses(): Array<string> {
        return this._witnesses;
    }

    set witnesses(value: Array<string>) {
        if (value) {
            this._witnesses = value;
        } else {
            this._witnesses = [];
        }
    }

    /* Witness hands involved  */
    get hands(): Array<string> {
        return this._hands;
    }

    set hands(value: Array<string>) {
        if (value) {
            this._hands = value;
        } else {
            this._hands = [];
        }
    }

    /* Textual variant causes */
    get causes(): Array<string> {
        return this._causes;
    }

    set causes(value: Array<string>) {
        if (value) {
            this._causes = value;
        } else {
            this._causes = [];
        }
    }
}

export class SearchEditionParams {
    private _pattern: string;
    private _section: SectionKey;
    private _slop: number;
    private _pagination: SearchEditionPagination;
    private _listApp: ListAppSearchParams;

    constructor() {
        this.init();
    }

    init(): void {
        this._pattern = '';
        this._section = EDITION_SECTIONS[0].key;
        this._slop = 1;
        this.resetPagination();
        this._listApp = new ListAppSearchParams();
    }

    resetPagination(): void {
        this._pagination = {'page': 1, 'limit': RESULTS_LIMIT};
    }

    /* Search pattern id filter */
    set pattern(value: string) {
        if (value) {
            this._pattern = value;
        } else {
            this._pattern = '';
        }
    }

    get pattern(): string {
        return this._pattern;
    }

    /* Section of the edition in which to search */
    set section(value: SectionKey) {
        if (value) {
            this._section = value;
        } else {
            this._section = EDITION_SECTIONS[0].key;
        }
    }

    get section(): SectionKey {
        return this._section;
    }

    /* Distance (proximity search) */
    set slop(value: number) {
        if (value) {
            this._slop = value;
        } else {
            this._slop = 1;
        }
    }

    get slop(): number {
        return this._slop;
    }

    /* Pagination settings */
    set pagination(value: SearchEditionPagination) {
        if (value) {
            this._pagination = value;
        } else {
            this.resetPagination();
        }
    }

    get pagination(): SearchEditionPagination {
        return this._pagination;
    }

    /* Critical apparatus filtering */
    set listApp(value: ListAppSearchParams) {
        if (value) {
            this._listApp = value;
        } else {
            this._listApp.init();
        }
    }

    get listApp(): ListAppSearchParams {
        return this._listApp;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/search-edition-params.ts